import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getAllBots } from '@entities/bot'
import { isActiveBotStatus } from './botStatus'

const parseBotData = (raw: string): DCABotSetData | null => {
  if (!raw) return null
  try {
    return JSON.parse(raw) as DCABotSetData
  } catch {
    return null
  }
}

// 전체 봇 리스트 + 각 항목의 botData JSON 파싱 결과 부착
export const useBotAllList = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['bot', 'all'],
    queryFn: getAllBots,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
    refetchOnReconnect: 'always',
    enabled,
  })

  const allItems = useMemo(() => {
    const list = data?.botList ?? []
    return list.map(b => ({
      ...b,
      setData: parseBotData(b.botData),
    }))
  }, [data])

  // 실행/재시작 대기(status 1/2)인 봇만 노출
  const items = useMemo(
    () => allItems.filter(b => isActiveBotStatus(b.status)),
    [allItems],
  )

  return { items, allItems, isLoading, refetch }
}
